function fStickyHeader() {
  const navBar = document.querySelector('.js-sticky-header');
  const stickyClass = 'header--sticky';
  let navBarHeight = navBar.offsetHeight;
  let isSticky = false;
  let watchScroll = false;

  const toggleStickyMenu = () => {
    if (navBar.classList.contains(stickyClass)) {
      navBar.classList.remove(stickyClass);
      website.body.style.paddingTop = null;
      isSticky = false;
    } else {

        var configurator = document.querySelectorAll('.configurator');

        for (let i = 0; i < configurator.length; i += 1) {
            if (configurator[i].style.display !== 'none')
                return;
        }

      navBar.classList.add(stickyClass);
      website.body.style.paddingTop = `${navBarHeight}px`;
      isSticky = true;
    }
  };

  const checkScrollPosition = () => {
    const scrollPosition = window.scrollY;

    if (scrollPosition > 0) {
      if (!isSticky) {
        toggleStickyMenu();
      }
    } else if (isSticky) {
      toggleStickyMenu();
    }
  };

  const addScrollListener = () => {
    window.addEventListener('scroll', checkScrollPosition);
    watchScroll = true;
  };

  const removeScrollListener = () => {
    window.removeEventListener('scroll', checkScrollPosition);
    watchScroll = false;
    if (isSticky) {
      toggleStickyMenu();
    }
  };

  window.addEventListener('resize', () => {
    navBarHeight = navBar.offsetHeight;
    /*
            Using a Timeout here because otherwise
            the iScreenWidth is calculated after the resize
            when using the windows fullscreen toggle
        */
    setTimeout(() => {
      //if (website.iScreenWidth < website.mobileBreakpoint) {
        if (!watchScroll) {
          addScrollListener();
        }
      //} else {
      //  removeScrollListener();
      //}
    }, 0);
  });

  if (/*website.iScreenWidth < website.mobileBreakpoint &&*/ !watchScroll) {
    addScrollListener();
  }
}
